import * as React from 'react';

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

import { confirmable, ConfirmDialog, ConfirmDialogProps } from 'react-confirm';

export interface Props {
  okLabel?: string;
  cancelLabel?: string;
  title?: string;
  confirmation?: string;
  inputText?:string;
};
export interface ConfirmationResult {
  ok: boolean;
  text?:string;
}

const Confirmation: React.FC<ConfirmDialogProps<Props, ConfirmationResult>> = (props) => {  
  const textAreaRef = React.useRef<HTMLTextAreaElement>(null);

  return (<div className="static-modal">
    <Modal animation={false} show={props.show} onHide={() => props.proceed({ok: false})} backdrop={true}>
      <Modal.Header>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.confirmation}
        {props.inputText ? <textarea ref={textAreaRef} rows={3} cols={60} style={{padding: '3px'}} defaultValue={props.inputText}> 
        </textarea> : null}
      </Modal.Body>
      <Modal.Footer>
        {props.cancelLabel!=null?<Button onClick={() => props.proceed({ok:false})}>{props.cancelLabel}</Button>:null}
        <Button className='button-l' 
                onClick={() => props.proceed({ok:true, text: textAreaRef!=null && textAreaRef.current!=null && textAreaRef.current.value != null ? textAreaRef.current.value : '' })}>
                  {props.okLabel || 'OK'}
        </Button>
      </Modal.Footer>
    </Modal>
  </div>);
};

export default confirmable(Confirmation);